import {
  CalendarDetailsVisibility,
  SyncMode,
  TranslateFunction,
} from '@griply/types';

export type CalendarSyncFieldOption = {
  value: string;
  label: string;
};

export type CalendarSyncFieldOptions = {
  modeOptions: CalendarSyncFieldOption[];
  visibilityOptions: CalendarSyncFieldOption[];
};

// The configured row and the add dialog offer the same two enums; one builder keeps a label
// from drifting between the surface that creates a sync and the one that edits it.
export const getCalendarSyncFieldOptions = (
  t: TranslateFunction,
): CalendarSyncFieldOptions => ({
  modeOptions: [
    {
      value: SyncMode.Automatic,
      label: t('calendar.sync-tasks.mode.automatic'),
    },
    {
      value: SyncMode.Manual,
      label: t('calendar.sync-tasks.mode.manual'),
    },
  ],
  visibilityOptions: [
    {
      value: CalendarDetailsVisibility.Visible,
      label: t('calendar.sync-tasks.visibility.visible'),
    },
    {
      value: CalendarDetailsVisibility.Hidden,
      label: t('calendar.sync-tasks.visibility.hidden'),
    },
  ],
});
